import React from 'react';
import '../styles/CompanyOverview.css';


const CompanyOverview = () => {
  return (
<>
      <div className="image-container">
        <img 
          src='assets/overview.jpeg'
          alt="Dr. BhuPat Pharma Team" 
          className="company-image"
        />
      </div>
          <div className="containero">
      <section className="aboutUs">
        <h2 className="title">Company Overview</h2>
        <p className="description">
          Welcome to Dr. BhuPat Pharma Pvt. Ltd., a young pharmaceutical company headquartered in Chh. Sambhajinagar, dedicated to women's health and wellness established in 2024. Our mission is to improve the lives of women by providing innovative and effective healthcare solutions. With a strong focus on gynecological care, we strive to empower women to take control of their reproductive health.
        </p>
        
        <div className="featuresGrid">
          <div className="featuresCard">
            <h3 className="featureTitle">Our Presence</h3>
            <p className="featureText">
              Dr. BhuPat Pharma has a strong presence in Maharashtra, India, and is expanding day by day to other states. The qualified employees are the backbone and brand ambassadors who meet doctors across Maharashtra every month.
            </p>
          </div>
          <div className="featuresCard">
            <h3 className="featureTitle">Our Commitment</h3>
            <p className="featureText">
              We are committed to providing the best quality medicines to heal, cure, and empower women to take control of their reproductive health. Our dedication to excellence drives every aspect of our operations.
            </p>
          </div>
        </div>

        <div className="highlightBox">
          <h3 className="highlightTitle">Key Features</h3>
          <ul className="featureList">
            <li>Specialized in Women's Healthcare</li>
            <li>Strong Research and Development Focus</li>
            <li>Quality-Driven Manufacturing</li>
            <li>Pan-Maharashtra Presence</li>
            <li>Dedicated Professional Team</li>
          </ul>
        </div>
      </section>
    </div>
    </>
  );
};

export default CompanyOverview;